<div mat-dialog-content class="form-container">
        <form  class="form__datosCentroContratista">
          <h1>Asignación de Nuevo Cliente</h1>
  
          <h2>Clientes e Instalaciones</h2>
          <div class="datos__datos">
            <p *ngIf="clienteSeleccionado" style="color: red;">Al cliente le quedan {{contadorLicencia}} licencia(s) por asignar a un centro</p>
            <p *ngIf="clientes?.length == 0" style="color: red;">Ya tiene todos sus clientes asignados a este centro.</p>
            <mat-form-field appearance="outline">
  
              <mat-label>Asignar Cliente</mat-label>
              <mat-select name="cliente" [(value)]="clienteSeleccionado" (selectionChange)="selectCliente($event.value)" >
                <mat-option *ngFor="let cliente of clientes" [value]="cliente.id" >
                  {{cliente.nombreComercial}}
                </mat-option>
              
            </mat-select>
            </mat-form-field>
            <ng-container *ngIf="instalaciones?.length > 0">
               <mat-form-field appearance="outline">
              <mat-label>Instalaciones del cliente</mat-label>
              <mat-select multiple >
                <mat-option (click)="selectAllInstalaciones($event)"><strong>Todas las instalaciones</strong></mat-option>
                  <mat-option *ngFor="let instalacion of instalaciones" [value]="instalacion.id" #matOption (click)="selectInstalacion(matOption)">{{instalacion.nombre}}</mat-option>
              </mat-select>
            </mat-form-field>
          </ng-container>
          <ng-container *ngIf="instalaciones?.length == 0">
            <mat-form-field appearance="outline">
              <mat-label>Instalaciones del cliente</mat-label>
              <mat-select  multiple>
                <mat-option  [value]="null" #matOption (click)="selectInstalacion(matOption)">No tiene Instalaciones</mat-option>
              </mat-select>
            </mat-form-field>
          </ng-container>
          </div>
          <button type="submit"  [mat-dialog-close] (click)="updateCentroById()" *ngIf="clientes.length == 0" disabled style="background-color: darkgrey;">
            Hecho
          </button>
          <button type="submit"  [mat-dialog-close] (click)="updateCentroById()" *ngIf="clientes.length > 0">
            Hecho
          </button>
        </form>
  
        </div>
